import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-notify-additional-guest-info-dialog',
  templateUrl: './notify-additional-guest-info-dialog.component.html',
  styleUrls: ['./notify-additional-guest-info-dialog.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule, 
    MatDialogModule
  ]
})
export class NotifyAdditionalGuestInfoDialogComponent {

  constructor(public dialogRef: MatDialogRef<NotifyAdditionalGuestInfoDialogComponent>) { }

  onConfirmClick(): void {
    this.dialogRef.close();
  }
}